import * as React       from 'react';
import Box              from "@mui/material/Box";
import Typography       from "@mui/material/Typography";
import Container        from "@mui/material/Container";
import Button           from '@mui/material/Button';
import useMediaQuery    from '@mui/material/useMediaQuery';
import useTheme         from '@mui/material/styles/useTheme';
import {
    useNavigate,
    useOutletContext
}                       from 'react-router-dom';
import ClassesTable     from 'ui/components/classes-components/ClassesTable';
import ClassFlow        from 'ui/components/classes-components/ClassFlow';
import NavBar           from 'ui/components/classes-components/NavBar';
import { IOutletContext } from 'ui/components/Dashboard';
import {
    CLASSES_TABLE_HEADER,
    CREATE_CLASS_BUTTON
}                       from "config/config";
import { useSession } from 'auth/AuthProvider';


export default function Classes() {
    const [flowOpen, setFlowOpen] = React.useState(false);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    const session = useSession();
    const {
        setBgcolor,
        setTopBarColorLight
    } = useOutletContext<IOutletContext>();
    React.useEffect(()=>{
        setBgcolor('background.paper');
        setTopBarColorLight("background.paper");
    },[setBgcolor, setTopBarColorLight]);
    return(
        <Container maxWidth='lg' sx={{pt: 2}}>
            <Box sx={{px: matches? 6: 0}}>
                <NavBar/>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: "space-between",
                    mb: 1,
                    mt: 6,
                    px: 0
                }}>
                    <Typography variant="h5" fontWeight={500} fontSize={32}>
                        {CLASSES_TABLE_HEADER}
                    </Typography>
                    { session.organization_source === 'teacher' &&
                    <Button
                        variant='contained'
                        sx={{fontSize: 17, px: matches? 3: 1}}
                        onClick={()=>setFlowOpen(true)}
                    >
                        {CREATE_CLASS_BUTTON}
                    </Button>
                    }
                </Box>
                <ClassesTable/>
            </Box>
            <ClassFlow
                open={flowOpen}
                initialStep="create"
                onClose={()=>setFlowOpen(false)}
                onFinish={(classId)=>{ setFlowOpen(false); navigate(`/classes/${classId}`); }}
            />
        </Container>
    );
};
